import classnames from "classnames";
import PropTypes from "prop-types";
import plate from "./Plate.module.scss";

export const Plate = ({
  children,
  isClickable = false,
  onClick,
  customClassName,
}) => {
  return (
    <div
      tabIndex={isClickable ? 0 : undefined}
      onClick={onClick}
      className={classnames({
        [plate.BLOCK]: true,
        [plate.BLOCK___clickable]: isClickable,
        [customClassName]: true,
      })}
    >
      <div className={plate.inner}>{children}</div>
    </div>
  );
};

Plate.propTypes = {
  isClickable: PropTypes.bool,
  onClick: PropTypes.func,
  customClassName: PropTypes.string,
};
